import React, { Component } from 'react';
import { connect } from 'react-redux';
import { HeaderShape } from '../../../../types/index';
import { HEADER_BACKGROUND_BREAKPOINTS } from './constants';
import './HeaderBackground.scss';

const SIZES = '(max-width: 1920px) 1920px, 1924px';

const IMAGE_INTRINSIC_SIZES: { [key: string]: number } = {
    desktop: 1920,
    twok: 1924,
};

const makeImageSetString = (imageSet?: { [key: string]: any }) => {
    const defaultImage = imageSet?.mobile;
    const imageSetKeys = Object.keys(imageSet || {});

    const setString = imageSetKeys.reduce((acc, key, index) => {
        const fileName = imageSet?.[key];
        const width = IMAGE_INTRINSIC_SIZES[key];

        if (!width) {
            return acc;
        }

        return (acc += `${fileName} ${width}w${
            imageSetKeys.length === index - 1 ? '' : ','
        }`);
    }, '');

    return { default: defaultImage, srcSet: setString };
};

interface HeaderBackgroundProps {
    imageSet?: { [key: string]: any };
    headerImages?: object;
    placeholder?: { color?: string };
}

const MainHeaderBackgroundImageSet = ({
    imageSet,
    placeholder,
}: HeaderBackgroundProps) => {
    const formattedImageSet = makeImageSetString(imageSet);

    return (
        <>
            <source
                media={`(max-width: ${HEADER_BACKGROUND_BREAKPOINTS['tablet']}px)`}
                srcSet={imageSet?.['mobile']}
            />
            <source
                media={`(max-width: ${HEADER_BACKGROUND_BREAKPOINTS['desktop']}px)`}
                srcSet={imageSet?.['tablet']}
            />
            {
                <img
                    //HTML Img Definition doesnt support fetchpriority but it
                    //is supported in chrome and edge with broader support coming
                    //https://caniuse.com/mdn-html_elements_img_fetchpriority
                    //eslint-disable-next-line
                    //@ts-ignore
                    fetchpriority="high"
                    className="fullbleed-header__main-bg"
                    src={formattedImageSet.default}
                    alt="Homepage header"
                    srcSet={formattedImageSet.srcSet}
                    sizes={SIZES}
                    style={{ backgroundColor: placeholder?.color }}
                    loading="eager"
                />
            }
        </>
    );
};

export class FullbleedHeaderBackground extends Component<HeaderBackgroundProps> {
    render() {
        const { placeholder, headerImages } = this.props;

        return (
            <div className="fullbleed-header__main-bg-wrapper">
                <picture>
                    <MainHeaderBackgroundImageSet
                        imageSet={headerImages || {}}
                        placeholder={placeholder || {}}
                    />
                </picture>
            </div>
        );
    }
}

const _mapStateToProps = ({ header }: { header: HeaderShape }) => ({
    headerImages: header.images,
});

export default connect(_mapStateToProps)(FullbleedHeaderBackground);
